module.exports = __webpack_public_path__ + "static/img/ex_logo_25.54b1871.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ex/ex_logo_25.jpg
// module id = nFeT
// module chunks = 0